const message = {
    verifyMessage:"賬號錯誤或者存在多個，請聯系客服處理",
    noGoodsMessage:"未選擇商品種類",
    noPayTypeMessage:'未選擇支付方式',
    noAcceptMessage:"未同意條款",
    noAccountMessage:"未輸入賬號",
    buyLinkFailMessage:"獲取支付鏈接失敗，請聯系客服處理",
}
const buyInfo = {
    topTitleLeft:"口袋外匯",
    topTitleRight:"支付中心",
    buyTitle:"P币",
    account:"口袋賬號",
    payMethod:"支付方式",
    payButtonContent:"支付",
    acceptTerms:"我已確認已閲讀《服務條款》和《隱私政策》並接受所有條款。",
    inputDefaultContent:"請輸入你的口袋賬號",
    vipBuyTitle:"VIP會員",
    month:"個月",
    save:"立省",
    noSave:"無折扣",
}
const resultInfo = {
    content:"正在查詢支付結果...",
    successText:"購買成功",
    buttonText:"返回首頁",
    failText:"購買失敗"
}
const orderInfo = {
    payment:"支付金额",
}
const title={
    pbTitle:"P幣充值",
    vipTitle:"購買Vip會員",
}

export default {buyInfo,resultInfo,orderInfo,message,title}